import apiService from '@/utils/request';
import { parseURI, objectToQueryString } from '@/utils';

const URIs = {
  declaraciones: '/v1/declaraciones',
  justificante: '/v1/declaraciones/{0}/justificante',
  cartadepago: '/v1/declaraciones/{0}/cartadepago',
  pagosdetasas: '/v1/declaraciones/{0}/pagotasa',
  notificacionesWeco: '/v1/declaraciones/weco'
};

export function newDeclaracion(payload) {
  let uri = parseURI(URIs.declaraciones);
  return apiService.post(uri, payload);
}

export function getUltimaActulizacion() {
  var urlStr = parseURI(URIs.notificacionesWeco + '/actulizacion');
  return apiService.get(urlStr);
}

export function getJustificante(cdregist) {
  let uri = parseURI(URIs.justificante, cdregist);
  return apiService.get(uri, { responseType: 'arraybuffer' });
}

export function getCartaDePago(cdregist) {
  let uri = parseURI(URIs.cartadepago, cdregist);
  return apiService.get(uri, { responseType: 'arraybuffer' });
}

export function getDeclaraciones(payload) {
  let uri = parseURI(URIs.declaraciones);
  uri += objectToQueryString(payload);
  return apiService.get(uri);
}

export function getPagosDeTasas(jus) {
  let uri = parseURI(URIs.pagosdetasas, jus);
  return apiService.get(uri);
}
